<template>
  <div>
    <model-table
      :data="foods"
      :noItemLabel="$t('compCarbonFormsFoodsTable.no-meal')"
      :module="module"
      :disabled="isSubmitted || isClonedSurvey"
      :singleUpdateDisabled="true"
      :bulkOpsDisabled="true"
      :withTags="authStore.isAuthenticated"
      @update="$emit('update')"
      @edit="(item) => display(item)"
      @del="(items) => $emit('del', items)"
    >
      <template slot="validity" slot-scope="props">
        <b-tag rounded v-if="props.props.row.mdeleted">{{
          $t('compCarbonFormsFoodsTable.state-1')
        }}</b-tag>
        <b-tag rounded v-else type="is-success">{{
          $t('compCarbonFormsFoodsTable.state-2')
        }}</b-tag>
      </template>
      <b-table-column
        field="seqID"
        sortable
        :label="$t('id')"
        centered
        numeric
        v-slot="props"
        :td-attrs="maskedOnTest"
      >
        <del v-if="props.row.mdeleted">{{ props.row.seqID }}</del>
        <span v-else>{{ props.row.seqID }}</span>
      </b-table-column>
      <b-table-column
        field="position"
        sortable
        :label="$t('position')"
        centered
        numeric
        v-slot="props"
      >
        <del v-if="props.row.mdeleted">{{ $t(props.row.position) }}</del>
        <span v-else>{{ $t(props.row.position) }}</span>
      </b-table-column>
      <b-table-column
        field="nWorkingDay"
        sortable
        :label="$t('compCarbonFormsFoodsTable.field-3')"
        numeric
        v-slot="props"
      >
        <del v-if="props.row.mdeleted">{{ props.row.nWorkingDay }}</del>
        <span v-else>{{ props.row.nWorkingDay }}</span>
      </b-table-column>
      <b-table-column
        :label="$t('compCarbonFormsFoodsTable.field-4')"
        v-slot="props"
      >
        <del v-if="props.row.mdeleted">{{ getLabel(props.row) }}</del>
        <span v-else>{{ getLabel(props.row) }}</span>
      </b-table-column>
      <template slot="delete" slot-scope="props">
        <b-tooltip :label="delLabel(props.props.row)" type="is-black">
          <b-button
            :disabled="isSubmitted || isClonedSurvey"
            size="is-small"
            :icon-right="delIcon(props.props.row)"
            @click="delFunction(props.props.row)"
            data-testId="maskedOnTest"
          />
        </b-tooltip>
      </template>
    </model-table>
    <b-modal
      :active.sync="displayModal"
      has-modal-card
      :can-cancel="['escape', 'x', 'outside']"
      :width="1000"
    >
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compCarbonFormsFoodsTable.field-5') }}
          </p>
        </header>
        <section class="modal-card-body">
          <survey-summary
            :survey="food"
            :isSimulation="false"
            :isSurvey="false"
            :year="year"
          />
          <br />
          <b-notification :closable="false" :has-icon="true" :icon="'envelope'">
            <strong>{{ $t('compCarbonFormsFoodsTable.label-1') }}</strong>
            <br />
            <span v-if="food.message">
              {{ food.message }}
            </span>
            <span v-else>
              {{ $t('compCarbonFormsFoodsTable.label-2') }}
            </span>
          </b-notification>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { useAuthenticationStore } from '@/stores/authentication.js'
import Food from '@/models/carbon/Food.js'
import Modules from '@/models/Modules.js'
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'Table',
  emits: ['update', 'del', 'view'],
  setup () {
    const authStore = useAuthenticationStore()
    const ghgiStore = useGHGIStore()
    return { authStore, ghgiStore }
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'model-table': () => import('@/components/carbon/forms/ModelTable.vue'),
    'survey-summary': () =>
      import('@/components/carbon/forms/survey/Summary.vue')
  },
  data () {
    return {
      food: Food.createEmpty(),
      displayModal: false
    }
  },
  computed: {
    foods: function () {
      return this.ghgiStore.items(Modules.FOODS)
    },
    module: function () {
      return Modules.FOODS
    },
    year: function () {
      return this.ghgiStore.item.year
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    },
    isClonedSurvey: function () {
      return this.ghgiStore.isClonedSurvey
    }
  },
  methods: {
    maskedOnTest: function (row, column) {
      return { 'data-testId': 'maskedOnTest' }
    },
    delFunction: function (item) {
      this.$emit('del', [item])
    },
    delIcon: function (item) {
      let icon = 'trash'
      if (!this.editable && item.mdeleted) {
        icon = 'undo'
      }
      return icon
    },
    delLabel: function (item) {
      let label = this.$t('delete')
      if (!this.editable && !item.mdeleted) {
        label = this.$t('compCarbonFormsFoodsTable.tooltip-1')
      } else if (!this.editable && item.mdeleted) {
        label = this.$t('compCarbonFormsFoodsTable.tooltip-2')
      }
      return label
    },
    display: function (food) {
      this.food = food
      this.displayModal = true
    },
    getLabel (food) {
      let label = ''
      for (let meal of food.meals) {
        label += meal.amount + ' ' + this.$t(meal.type) + ', '
      }
      label = label.slice(0, -2)
      if (label === '') {
        label = '-'
      }
      return label
    }
  }
}
</script>
